import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Component({
  selector: 'fc-date-input',
  templateUrl: './fc-date-input.component.html',
  styleUrls: ['./fc-date-input.component.scss']
})
export class FcDateInputComponent implements OnInit, OnDestroy {
  @Input()
  public control: FormControl;

  @Input()
  public label: string;

  @Input()
  public placeholder: string;

  @Input()
  public translateErrorPrefix: string;

  @Input()
  public max: any;

  @Input()
  public min: any;

  @Input()
  public required: boolean;

  @Input()
  public hasGroupError: boolean;

  @Input()
  public fixedColor = true;

  public colorIcon: boolean;

  private readonly removeSubscriptions = new Subject<void>();

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  public ngOnInit(): void {
    this.updateColorIcon();
    this.control.valueChanges.pipe(
      takeUntil(this.removeSubscriptions)
    ).subscribe(() => {
      this.updateColorIcon();
    });
  }

  public ngOnDestroy(): void {
    this.removeSubscriptions.next();
    this.removeSubscriptions.complete();
  }

  public updateColorIcon(): void {
    this.colorIcon = this.control.valid && this.control.value !== null;
  }
}
